const NOME_APP = "OMEGA";
const DESCRICAO_APP = "Sistema de Controle e Gestão de Obras da Construção Civil";
const VERSAO_APP = "v1.0.0";

const API_URL = process.env.REACT_APP_URL;
const API_CONTEXT = process.env.REACT_APP_API_CONTEXT;
const API_ID = process.env.REACT_APP_CLIENT_ID;
const API_KEY = process.env.REACT_APP_CLIENT_SECRET;
const SESSION_TOKEN_KEY = process.env.REACT_APP_SESSION_TOKEN_KEY;
const TIMEOUT_DEFAULT = process.env.REACT_APP_TIMEOUT ? parseInt(process.env.REACT_APP_TIMEOUT, 10) : 30000;

export default {
  NOME_APP,
  DESCRICAO_APP,
  VERSAO_APP,
  API_URL,
  API_CONTEXT,
  API_ID,
  API_KEY,
  TIMEOUT_DEFAULT,
  SESSION_TOKEN_KEY
};



// WEBPACK FOOTER //
// ./src/constantes/Config.js